export default __webpack_public_path__ + "static/media/android.93cc90ec.svg";